import PropTypes from 'prop-types';
import React, { Component } from 'react';
import media from 'decorators/Media/Media';
import trackDwell from 'decorators/TrackDwell/TrackDwell';
import { Heading } from 'components/Heading/Heading';
import { ResponsiveCarouselSm } from './ResponsiveCarouselSm';
import { ResponsiveCarouselLg } from './ResponsiveCarouselLg';

export class ResponsiveCarouselUnwrapped extends Component {
  onDwell() {
    const { handleDwell } = this.props;
    if (handleDwell) {
      handleDwell();
    }
  }

  render() {
    const { children, extraClass, handleSlide, header, loading, mediaQueryLg } = this.props;

    if (loading || !children || !children.length) {
      return false;
    }

    const CarouselComponent = mediaQueryLg ? ResponsiveCarouselLg : ResponsiveCarouselSm;

    return (
      <div className="carousel--responsive">
        {header && <Heading className="delta mb-large">{header}</Heading>}
        <CarouselComponent extraClass={extraClass} loading={loading} handleSlide={handleSlide}>
          {children}
        </CarouselComponent>
      </div>
    );
  }
}

ResponsiveCarouselUnwrapped.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  extraClass: PropTypes.string,
  handleDwell: PropTypes.func,
  handleSlide: PropTypes.func,
  header: PropTypes.string,
  loading: PropTypes.bool,
  mediaQueryLg: PropTypes.bool,
};

export const ResponsiveCarousel = media(trackDwell(ResponsiveCarouselUnwrapped));
